/***********************************************************
V 1.0.0 - Criado por Francielle Nunes

DESCIÇÃO:
Serviço de requisições http

COMPONENTS
***********************************************************/
import { Injectable } from '@angular/core';
import { HttpService } from './http';
import { StorageService } from './storage';

@Injectable()
export class GlobalService {

    private _itemSelecionado: any = [];
    public qtdNotificacoes: number = 0;

    constructor(
        private HttpService: HttpService,
        private StorageService: StorageService
    ) { }

    /************
    MARCA ITEM
    *************/
    marcaItem(item) {
        if (item.token) {
            this.StorageService.setItem("t",item.token);
        }
        return this._itemSelecionado = item;
    }



    /************
    GET ITEM
    *************/
    getItem() {
        let item = this._itemSelecionado;
        return item;
    }

    /* getQtdNotificacoes() {
        return this.HttpService.JSON_GET('/notificacoes', false, true)
            .then(
            res => {
                this.qtdNotificacoes = res.json().length;
            }
            )
    } */

    getLogout() {
        this.StorageService.removeItem('isLogged');
        this.StorageService.removeItem('nameUser');
        location.reload();
    }

}



// WEBPACK FOOTER //
// ./src/app/globals/globals.ts